// components/ModalCambiarClave.jsx
import React, { useState, useEffect, useContext } from "react";
import {
    Form,
    Input,
    Button,
    Modal,
    notification,
    Alert,
    Popover,
    Typography,
    Space
} from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LoginService from "services/LoginService";
import GestionarClaveService from "services/GestionarClaveService";
import ActualizarClaveService from "services/ActualizarClaveService";
import { SecurityContext } from "context/SecurityContextProvider";
import { VersionApiColaborador } from "enum/VersionApiColaborador";

const { Link } = Typography;
const subdominio = window.location.host.split(".")[0];

const ModalCambiarClave = ({ visible, onClose }) => {
    const [form] = Form.useForm();
    const history = useHistory();
    const { getVersionApiColaborador, getUsuarioAutenticado } = useContext(SecurityContext);
    
    const [loading, setLoading] = useState(false);
    const [mensajeError, setMensajeError] = useState("");
    const [politicasActivas, setPoliticasActivas] = useState([]);
    
    const isExplomin = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837";

    useEffect(() => {
        if (visible) {
            cargarPoliticas();
            form.resetFields();
            setMensajeError("");
        }
    }, [visible]);

    const cargarPoliticas = async () => {
        try {
            const datos = await GestionarClaveService.obtenerPoliticas(
                LoginService.getUsuarioAutenticado().subdominio
            );
            setPoliticasActivas(datos);
        } catch (error) {
            console.error("Error al cargar políticas:", error);
        }
    };

    const handleOnFinish = async (formulario) => {
        try {
            setLoading(true);
            const mensajeValidacion = await ActualizarClaveService.cambiarClave(
                getUsuarioAutenticado().subdominio,
                getUsuarioAutenticado().numeroDocumentoIdentidad,
                formulario.clave,
                formulario.claveActual
            );
            
            const mensaje = mensajeValidacion?.message || null;
            setMensajeError(mensaje);
            setLoading(false);
            
            if (!mensaje) {
                LoginService.actualizarCambiarClaveAlIniciarSesion(false);
                
                notification.success({
                    message: "Operación exitosa",
                    description: "Se actualizó su clave correctamente.",
                });
                
                onClose();
                
                // Redirigir según versión
                if (getVersionApiColaborador() === VersionApiColaborador.v1) {
                    history.push("/bandejaEntrada");
                } else if (getVersionApiColaborador() === VersionApiColaborador.v2) {
                    history.push("/mis-documentos");
                } else if (getVersionApiColaborador() === VersionApiColaborador.v3) {
                    history.push("/v3/mis-pendientes");
                } else {
                    history.push("/bandejaEntrada");
                }
            }
        } catch (error) {
            setLoading(false);
            console.error(error);
            notification.error({
                message: "No se puede guardar la clave",
                description: "Error: " + (error.response?.data?.mensaje || "Error desconocido"),
            });
        }
    };

    const contentPoliticas = (
        <div>
            {politicasActivas?.map((politica, index) => (
                <p key={index} style={{ margin: "4px 0" }}>{politica}</p>
            ))}
        </div>
    );

    return (
        <Modal
            title="Cambiar Clave"
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width="90%"
            style={{ maxWidth: 400 }}
        >
            {mensajeError && (
                <Alert
                    style={{ marginBottom: 16 }}
                    message={mensajeError}
                    type="error"
                    showIcon
                />
            )}
            
            <Form
                form={form}
                layout="vertical"
                onFinish={handleOnFinish}
            >
                <Form.Item
                    label="Clave Actual"
                    name="claveActual"
                    rules={[
                        {
                            required: true,
                            message: "Ingrese su clave actual",
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label={isExplomin ? "Nueva Clave" : "Clave"}
                    name="clave"
                    rules={[
                        {
                            required: true,
                            message: "Ingrese su clave",
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label={isExplomin ? "Repetir Nueva Clave" : "Repetir Clave"}
                    name="claveR"
                    dependencies={["clave"]}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: "Ingrese nuevamente su clave",
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("clave") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject("Las claves deben ser iguales!");
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                {politicasActivas?.length > 0 && (
                    <div style={{ marginBottom: 16 }}>
                        <Popover content={contentPoliticas} title="Políticas de la clave">
                            <Link>Ver políticas de la clave</Link>
                        </Popover>
                    </div>
                )}

                <Form.Item style={{ marginBottom: 0 }}>
                    <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                        <Button onClick={onClose}>
                            Cancelar
                        </Button>
                        <Button
                            type="primary"
                            icon={<CheckOutlined />}
                            htmlType="submit"
                            loading={loading}
                        >
                            Guardar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalCambiarClave;